import React from 'react';
import { DatosPersonaEnvio, DatosPersonaEnvioProps } from './DatosPersonaEnvio';

type Props = Omit<DatosPersonaEnvioProps, 'labels' | 'labelsCO'>;

export const DatosDestinatario: React.FC<Props> = (props) => (
  <DatosPersonaEnvio
    {...props}
    labels={{
      titulo: 'Datos del destinatario',
      nombre: 'Nombre del destinatario',
      colonia: 'Colonia destinatario',
    }}
    labelsCO={{
      titulo: 'Datos del destinatario',
      nombre: 'Nombre del destinatario',
    }}
  />
);
